import PermissionContextProvider from "./context/PermissionContextProvider";
import PermissionsWrapped from "./components/PermissionsWrapped";
import { getTheme } from "../../../constants/getTheme";

const Permissions = () => {
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);
  return (
    <PermissionContextProvider>
      <PermissionsWrapped theme={theme} />
    </PermissionContextProvider>
  );
};

export default Permissions;
